<template>
  <!-- 页面容器 -->
  <div
    class="page-container"
  >
    <div>
      <!-- 页面头部 -->
      <div>
        <div
          class="page-card__header"
        >
          <el-row>
            <el-col :span="6">
              <span style="padding-right: 20px"> 名片投递总数（共 {{ aSum }}）</span>
            </el-col>
            <!-- <el-col :span="6">
              <el-input v-model="keyword">
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="serach"
                ></el-button>
              </el-input>
            </el-col> -->
          </el-row>
        </div>
      </div>
      <!-- 数据表格 -->
      <el-table :data="tableData" style="width: 100%; padding: 0 20px">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>

        <el-table-column prop="wx_user_detail.name" label="投递人" width="100"></el-table-column>
        <el-table-column prop="to_wx_user_detail.name" label="被投递人" width="100"></el-table-column>

        <el-table-column prop="content" label="内容" >
        </el-table-column>
        <el-table-column prop="is_agree" label="是否已接受" width="200" >
          <template slot-scope="scope">

            <div v-if="scope.row.is_agree">
              已接受
            </div>
            <div v-else>
              未接受
            </div>

          </template>
        </el-table-column>


        <el-table-column prop="create_time" label="时间" width="180">
        </el-table-column>

        <!-- 操作列 -->
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              type="text"
              class="action-btn--danger"
              @click="handleClick(scope.row)"
            >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="pagesize"
          :total="aSum"
          :page-count="pageCount"
          :current-page.sync="currentPage"
          background
          layout="prev, pager, next,jumper"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import api from "../../utils/api";

  export default {
    data() {
      return {
        keyword: '',
        changetype: true,
        changeID: 0,
        tableData: [],
        //分页
        // 总条目数 total
        aSum: 0,
        // 当前页数 currenr_page
        currentPage: 1,
        // 总页数 num_pages
        pageCount: 1,
        // 每页显示条目数 pagesize
        pagesize: 10,
        productImg:
          "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/avatar/",
      };
    },
    mounted() {
      this.getInfo();
    },

    methods: {
      // 获取名片投递列表数据
      getInfo() {
        let url = this.baseUrl + "/admin/cards/";
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = 1;
        });
      },

      // 分页切换
      handleCurrentChange(val) {
        let url = this.baseUrl + "/admin/cards/?page=" + val + '&search=' + this.keyword;
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = val;
        });
      },

      // 搜索名片
      serach() {
        let url = this.baseUrl + "/admin/cards/?search=" + this.keyword + '&page=1';
        api.fetchData(url).then((res) => {
          this.tableData = res.results;
          this.aSum = res.count;
          this.currentPage = 1;
        });
      },

      // 切换页面类型
      changePage() {
        this.changetype = true;
      },
      // 切换到命中页面
      changePage_hit() {
        this.changetype = false;
      },

      // 删除名片投递记录
      handleClick(row) {
        this.$confirm("将删除此条信息，是否继续", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let id = row.id;
          let url = this.baseUrl + "/admin/cards/" + id + "/";
          api.deleteData(url).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getInfo();
          });
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/admin/card.vue